// Base URL for the backend API + Socket.IO server.
// Set REACT_APP_API_URL in frontend/.env (or frontend/.env.production for a build)
// to point at the real backend once hosted. Falls back to local dev.
export const API_BASE_URL = process.env.REACT_APP_API_URL || '';
